import classNames from 'classnames';

import styles from './Divider.module.scss';

const Divider = ({ className }: { readonly className?: string }): JSX.Element => {
    return <hr className={classNames(styles.divider, className)} />;
};

export { Divider };
